/* eslint-disable camelcase */
import React from 'react'

import ChipRectangle from 'components/ChipRectangle'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'
import isHomeUrlLocationUtil from 'utils/location/is-home-url'

const ONLY_AT_AIRSHOP = 'Only at airshop'

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeOnlyAtAirshop (props) {
  const {
    isOnlyAtAirshopDiscount,
    isTrending,
    isViralOnTikTok,
    wasJustDropped,
    isGiftSet
  } = props

  if (
    isGiftSet ||
    !isOnlyAtAirshopDiscount ||
    isTrending ||
    isViralOnTikTok ||
    wasJustDropped ||
    isMixedCollectionUrlLocationUtil() ||
    isHomeUrlLocationUtil()
  ) {
    return <></>
  }

  return (
    <ChipRectangle>
      {ONLY_AT_AIRSHOP}
    </ChipRectangle>
  )
}
